import React, { useContext, useEffect, useRef, useState } from 'react';
import HighchartsReact from 'highcharts-react-official';
import * as Highcharts from 'highcharts';
import { withVisibility } from './collapsible-button-chart';
import { getOccupancyAndAverageDailyRate } from '../shared/services/data.service';
import { isErrorInfo } from '../../shared/interfaces/error-info.interface';
import { KPIChartsSearch, OccupancyAndAverageDailyRate } from '../../shared/models/kpis.model';
import { OccupancyAndAverageDailyRateDataContext } from '../shared/services/OccupancyAndAverageDailyRate-provider';

const TotalRevenueChart: React.FC<{ query: KPIChartsSearch }> = ({ query }) => {
  const data = useContext<OccupancyAndAverageDailyRate[] | null>(
    OccupancyAndAverageDailyRateDataContext
  );

  const [chartOptions, setChartOptions] = useState<Highcharts.Options>({
    chart: {
      type: 'column',
      showCheckbox: true
    },
    title: {
      text: 'GMV',
      align: 'left'
    },
    xAxis: {
      categories: [
        'Jan',
        'Feb',
        'March',
        'Apr',
        'May',
        'June',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
      ],
      crosshair: true,
      accessibility: {
        description: 'Months'
      }
    },
    yAxis: [
      {
        title: {
          text: 'Total'
        }
      }
    ],
    plotOptions: {
      column: {
        borderWidth: 0,
        pointPadding: 0
      }
    },
    series: [
      {
        type: 'column',
        name: 'Total',
        data: [],
        color: '#1d4ed8',
        yAxis: 0
      }
    ]
  });
  const chartComponentRef = useRef(null);

  const getOccupancyAndAverageDailyRates = (response: OccupancyAndAverageDailyRate[]) => {
    chartComponentRef?.current?.chart?.hideLoading();
    const categories = response.map((revenue) => revenue.month.slice(0, 3).toUpperCase());
    // const egpMonthsRevenue = response.map((revenue) => revenue?.MonthlyRevenueEGP);
    // const usdMonthsRevenue = response.map((revenue) => revenue?.MonthlyRevenueUSD);
    const totalMonthsRevenue = response.map((revenue) => revenue?.MonthlyRevenueTotal);

    const chartUpdatedOptions = {
      ...chartOptions,
      xAxis: {
        ...chartOptions.xAxis,
        categories
      },
      series: [
        { ...chartOptions?.series?.[0], data: totalMonthsRevenue || [] }
        // { ...chartOptions.series[0], data: egpMonthsRevenue },
        // { ...chartOptions.series[1], data: usdMonthsRevenue }
      ]
    };
    setChartOptions(chartUpdatedOptions);
  };

  useEffect(() => {
    if (data) {
      getOccupancyAndAverageDailyRates(data);
    } else {
      chartComponentRef?.current?.chart?.showLoading();
    }
  }, [data]);

  return <HighchartsReact ref={chartComponentRef} highcharts={Highcharts} options={chartOptions} />;
};

export default withVisibility(TotalRevenueChart);
